import React, {Component, PropTypes} from 'react';
import BaseToggle from './base-toggle';
import {CircleSolidGreen} from 'cap-it-ui.icons';

import '../styles/radio.scss';

function changeHandler(value, event) {
    const radioButtonIsAlwaysSelected = true;

    this.props.onChange(value, radioButtonIsAlwaysSelected, event);
}

class Radio extends Component {
    static displayName = 'Radio';

    static propTypes = {
        children: PropTypes.string.isRequired,
        disabled: PropTypes.bool,
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        selected: PropTypes.bool.isRequired
    };

    render() {
        const {
            children,
            disabled,
            id,
            selected,
            name
        } = this.props;

        return (
            <BaseToggle
                className='radio-inline'
                disabled={disabled}
                icon={(<CircleSolidGreen/>)}
                id={id}
                name={name}
                onChange={changeHandler.bind(this)}
                selected={selected}
                type='radio'
            >
                {children}
            </BaseToggle>
        );
    }
}

export default Radio;



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/src/radio.js